import SponsorPage from './SponsorPage.tsx'

/**
 * Preview page — /preview/:slug
 *
 * Same component as SponsorPage but loads from 08-sponsors/pitches/draft/ instead
 * of 08-sponsors/pitches/ratified/. Used for sharing pitch with specific sponsor
 * before Directive #17 4-gate ratification completes.
 *
 * Access control (Phase F3): obscure slug + time-limited token in URL.
 * Currently unguarded scaffold; guard added during Phase F3 Day 2 execution.
 *
 * Displays a visible "PREVIEW — not for external share" banner so sharing mistakes
 * are obvious.
 */
export default function PreviewPage() {
  return (
    <div className="preview-wrapper">
      <div className="preview-banner" role="status">
        PREVIEW — unratified draft, not for external share
      </div>
      <SponsorPage />
    </div>
  )
}
